/* ************************************** */
/* * Top level evaluation page styles
/* ************************************** */
.background {
    display: flex;
    background: var(--mantine-color-dark-6);
    width: 100%;
    height: 100%;
}

.container {
    display: flex;
    width: 100%;
    overflow: hidden;
    max-width: 2000px;
    padding: 1.5rem 1.5rem 0.625rem;
    margin: 0 auto;
}

.calloutCard {
    grid-area: clt;
}

.content {
    grid-area: main;
}

.sidebar {
    grid-area: sd;
}

.evaluationGrid {
    display: grid;
    grid-template-columns: minmax(220px, 20%) auto;
    grid-auto-rows: auto;
    grid-gap: 1.5rem;
    width: 100%;
    grid-template-areas:
        "sd clt"
        "sd main";
}

@media (min-width: 900px) {
    .evaluationGrid {
        display: grid;
        grid-template-columns: minmax(220px, 25%) 50% auto;
        grid-template-areas: "sd main clt";
    }
}

@media (min-width: 75em) {
    .evaluationGrid {
        grid-template-columns: minmax(220px, 20%) 55% auto;
    }
}

.evaluationGridColumn {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
}

.scrollAreaViewport > div {
    padding-bottom: 0;
}

.scrollAreaViewport {
    scroll-behavior: smooth;
}

/* ************************************** */
/* * Evaluation transcript styles
/* ************************************** */
.stickyHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid var(--mantine-color-gray-8);
}

.sessionIdRight {
    display: flex;
}

.sessionIdLabel {
    display: inline-block;
    width: 100%;
    max-width: 185px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.transcriptBody {
    display: grid;
    grid-template-columns: 6rem auto;
    margin-bottom: 1.25rem;
    gap: 1em;
}

.scrollArea {
    flex: 0 1 30%;
    max-width: 100%;
    height: 100%;
}

.transcriptContainer {
    display: flex;
    padding: 0 1.5rem;
    height: 100%;
}

.callout {
    background-color: #933adc59;
    animation: 2s ease-in-out 2 highlight-pulse;
    cursor: pointer;
    padding: 0.1875rem;
    border-radius: 5px;
    color: #d8d8d8 !important;
}

/* ************************************** */
/* * Evaluation callout styles
/* ************************************** */
.calloutHeader {
    border-bottom: 1px solid var(--mantine-color-gray-8);
}

.calloutHeaderTitle {
    max-width: 225px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
}

@media (min-width: 900px) {
    .evaluationCallout {
        position: relative;
    }
}

/* ************************************** */
/* * SalesBehaviorChecklist styles
/* ************************************** */
.checklistContent {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: underline;
    text-decoration-color: transparent;
    transition: 0.2s;
}

.behaviorChecklistItem {
    cursor: pointer;
}

.behaviorChecklistItem:hover .checklistContent,
.activeChecklistItem .checklistContent {
    text-decoration-color: var(--mantine--color-white);
}

.behaviorChecklistItem.behaviorDisabled {
    cursor: not-allowed;
    opacity: 0.6;
    text-decoration-color: transparent;
}

.behaviorChecklistItem.behaviorDisabled:hover .checklistContent {
    text-decoration-color: transparent;
}
